package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PauseCircleW500Rounded: ImageVector
    get() {
        if (_pauseCircleW500Rounded != null) {
            return _pauseCircleW500Rounded!!
        }
        _pauseCircleW500Rounded = Builder(name = "PauseCircleW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(428.02f, 629.93f)
                quadTo(440.0f, 617.95f, 440.0f, 600.24f)
                verticalLineToRelative(-240.48f)
                quadToRelative(0.0f, -17.71f, -11.98f, -29.69f)
                reflectiveQuadToRelative(-29.7f, -11.98f)
                quadToRelative(-17.71f, 0.0f, -29.81f, 11.98f)
                quadToRelative(-12.1f, 11.98f, -12.1f, 29.69f)
                verticalLineToRelative(240.48f)
                quadToRelative(0.0f, 17.71f, 12.1f, 29.69f)
                reflectiveQuadToRelative(29.81f, 11.98f)
                quadToRelative(17.72f, 0.0f, 29.7f, -11.98f)
                close()
                moveTo(591.6f, 629.93f)
                quadToRelative(11.99f, -11.98f, 11.99f, -29.69f)
                verticalLineToRelative(-240.48f)
                quadToRelative(0.0f, -17.71f, -11.99f, -29.69f)
                quadToRelative(-11.98f, -11.98f, -29.69f, -11.98f)
                reflectiveQuadToRelative(-29.81f, 11.98f)
                quadTo(520.0f, 342.05f, 520.0f, 359.76f)
                verticalLineToRelative(240.48f)
                quadToRelative(0.0f, 17.71f, 12.1f, 29.69f)
                reflectiveQuadToRelative(29.81f, 11.98f)
                quadToRelative(17.71f, 0.0f, 29.69f, -11.98f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-84.91f, 0.0f, -159.34f, -32.12f)
                quadToRelative(-74.44f, -32.12f, -129.5f, -87.17f)
                quadToRelative(-55.05f, -55.06f, -87.17f, -129.5f)
                quadTo(71.87f, 564.91f, 71.87f, 480.0f)
                reflectiveQuadToRelative(32.12f, -159.34f)
                quadToRelative(32.12f, -74.44f, 87.17f, -129.5f)
                quadToRelative(55.06f, -55.05f, 129.5f, -87.17f)
                quadToRelative(74.43f, -32.12f, 159.34f, -32.12f)
                reflectiveQuadToRelative(159.34f, 32.12f)
                quadToRelative(74.44f, 32.12f, 129.5f, 87.17f)
                quadToRelative(55.05f, 55.06f, 87.17f, 129.5f)
                quadToRelative(32.12f, 74.43f, 32.12f, 159.34f)
                reflectiveQuadToRelative(-32.12f, 159.34f)
                quadToRelative(-32.12f, 74.44f, -87.17f, 129.5f)
                quadToRelative(-55.06f, 55.05f, -129.5f, 87.17f)
                quadTo(564.91f, 888.13f, 480.0f, 888.13f)
                close()
                moveTo(480.0f, 797.13f)
                quadToRelative(133.04f, 0.0f, 225.09f, -92.04f)
                quadToRelative(92.04f, -92.05f, 92.04f, -225.09f)
                quadToRelative(0.0f, -133.04f, -92.04f, -225.09f)
                quadToRelative(-92.05f, -92.04f, -225.09f, -92.04f)
                quadToRelative(-133.04f, 0.0f, -225.09f, 92.04f)
                quadToRelative(-92.04f, 92.05f, -92.04f, 225.09f)
                quadToRelative(0.0f, 133.04f, 92.04f, 225.09f)
                quadToRelative(92.05f, 92.04f, 225.09f, 92.04f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _pauseCircleW500Rounded!!
    }

private var _pauseCircleW500Rounded: ImageVector? = null
